// D3 graphs
import { bisector, extent, max } from "d3-array"
import { timeFormat, timeFormatDefaultLocale } from "d3-time-format"

// HighCharts
import { Highchart, Stockchart } from "@/lib/highcharts"
import {
	Highcharts,
	HighchartsReact,
	defaultOptions,
	miniOptions,
} from "@/lib/highchartsConfig"
import { UsersUserProfileLanguageChoices } from "@/api/graphql/types"

// Initialize
export const setLang = (lang: string) => {
	return new Promise<void>((resolve) => {
		// Set locale
		let locale
		switch (lang) {
			case UsersUserProfileLanguageChoices.Nl:
				void import("@/i18n/locales/nl/d3-time-format.json").then(
					(result) => {
						locale = result
						// @ts-expect-error - d3 locale JSON module shape differs from TimeLocaleDefinition type
						timeFormatDefaultLocale(locale)
						resolve()
						return
					},
				)
				break
			default:
				void import("@/i18n/locales/en/d3-time-format.json").then(
					(result) => {
						locale = result
						// @ts-expect-error - d3 locale JSON module shape differs from TimeLocaleDefinition type
						timeFormatDefaultLocale(locale)
						resolve()
						return
					},
				)
		}
	})
}

// Time formats commonly used throughout the app
export const formatYear = timeFormat("%Y")
export const formatMonth = timeFormat("%b %y")
export const formatDay = timeFormat("%d")

// Export D3
export { bisector, extent, max, timeFormat }

// HighCharts exports
export {
	Highcharts,
	HighchartsReact,
	defaultOptions,
	miniOptions,
	Highchart,
	Stockchart,
}
